/**
 * 拼接 entry 参数后打开链接
 * @param {string} url - 目标地址
 * @param {string} entry - 来源标识
 */
export function openWithEntry(url, entry) {
    if (!url) return
    try {
        const target = new URL(url)
        target.searchParams.set('entry', entry)
        window.open(target.href)
    } catch {
        window.open(url)
    }
}
